export const localHostConf = {
    enabled: false,
    url: 'http://localhost:8080'
}

export const url = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ?
        localHostConf.enabled ? localHostConf.url : 'http://rest-dev.kuzel.online' :
        'https://rest.kuzel.online';